import React from 'react';
import { LogoWhite } from '../../images/images';
import ActionsBarHeader from './ActionsBarHeader';
import { useNavigate } from 'react-router-dom';

const Header = props => {
    const navigate = useNavigate();

    const renderActionsBar = () => {
        return <ActionsBarHeader />;
    };

    const goToIndex = () => {
        navigate('/');
    };

    const renderTitle = () => {
        if (props.url && !props.url.split('/')[0]) {
            return '';
        }
        return props.title || '';
    };

    return (
        <div className="app__header__wrapper">
            <div className="app__header__container">
                <div className="app__header">
                    <div className="app__header__logo">
                        <img src={LogoWhite} alt="Logo Vouchedfor" onClick={goToIndex} />
                    </div>
                    <h1 className="vouchedfor-brand">{renderTitle()}</h1>
                    {renderActionsBar()}
                </div>
            </div>
        </div>
    );
};

export default Header;
